// Video model based on API::V1::Activity::V1::VideoSerializer
export default {

  // Images
  background_image: null,
  gradient_start: null,
  gradient_end: null,

  // Attributes
  identifier: null,
  label: null,
  headline: null,
  provider: null,
  code: null,
  complete_threshold: 0
}
